import React, { useContext } from "react";
import { BrowserRouter, Switch, Redirect, useLocation, Route as RouterRoute } from "react-router-dom";
import { ToastContainer } from "react-toastify";

import LoggedInLayout from "../layout";
//import Dashboard from "../pages/Dashboard/";
import Tickets from "../pages/Tickets/";
import Chat from "../pages/Chat/";
//import Signup from "../pages/Signup/";
import Login from "../pages/Login/";
import Connections from "../pages/Connections/";
//import Settings from "../pages/Settings/";
//import Users from "../pages/Users";
//import Contacts from "../pages/Contacts/";
import QuickAnswers from "../pages/QuickAnswers/";
import BlockedUser from "../pages/BlockedUser/";
import ForaHorarioAcesso from "../pages/ForaHorarioAcesso/";
import SessaoEncerrada from "../pages/SessaoEncerrada/";
import BackdropLoading from "../components/BackdropLoading";
//import Queues from "../pages/Queues/";
//import ZDG from "../pages/ZDG/";
//import ZDGMedia from "../pages/ZDGMedia/";
//import ZDGGroups from "../pages/ZDGGroups/";
//import InstaDirect from "../pages/InstaDirect/";
//import SMS from "../pages/SMS/";
//import VoiceCall from "../pages/VoiceCall/";
//import ZDGChatbot from "../pages/ZDGChatbot";
//import ZDGHistorico from "../pages/ZDGHistorico";
//import ZDGAgendamento from "../pages/ZDGAgendamento";
import { AuthContext, AuthProvider } from "../context/Auth/AuthContext";
import { WhatsAppsProvider } from "../context/WhatsApp/WhatsAppsContext";
import Route from "./Route";

const BLOCKED_PATH = "/blocked-user";
const OUT_OF_SCHEDULE_PATH = "/fora-horario-acesso";
const SESSION_ENDED_PATH = "/sessao-encerrada";

// Gate de topo: enquanto carrega, ou se o usuário está desativado / fora do horário de acesso
// numa rota operacional, não monta WhatsAppsProvider/LoggedInLayout/Tickets/Chat — redireciona
// para a tela do motivo.
const AppGate = () => {
  const { user, loading } = useContext(AuthContext);
  const location = useLocation();

  if (loading) {
    return <BackdropLoading />;
  }

  const isInactive = user && user.ativo === false;
  if (isInactive && location.pathname !== BLOCKED_PATH) {
    return <Redirect to={BLOCKED_PATH} />;
  }

  // Depois do desativado: usuário desativado E fora do horário vê o bloqueio, que é definitivo.
  const isOutOfSchedule = user && user.foraHorarioAcesso === true;
  if (isOutOfSchedule && location.pathname !== OUT_OF_SCHEDULE_PATH) {
    return <Redirect to={OUT_OF_SCHEDULE_PATH} />;
  }

  return (
    <Switch>
      <Route exact path="/login/:email/:senha/:tela/:id?" component={Login} />
      {/* Rotas de bloqueio FORA do WhatsAppsProvider — zero contexto operacional */}
      <RouterRoute exact path={BLOCKED_PATH} component={BlockedUser} />
      <RouterRoute exact path={OUT_OF_SCHEDULE_PATH} component={ForaHorarioAcesso} />
      {/* Destino do "Sair": sem rota própria, a navegação teria de cair numa rota privada, que
          monta WhatsAppsProvider/LoggedInLayout sem token. */}
      <RouterRoute exact path={SESSION_ENDED_PATH} component={SessaoEncerrada} />
      {/* <Route exact path="/signup" component={Signup} /> */}
      <WhatsAppsProvider>
        <LoggedInLayout>
          {/* <Route exact path="/" component={Dashboard} isPrivate /> */}
          <Route
            exact
            path="/tickets/:ticketId?"
            component={Tickets}
            isPrivate
          />
          <Route
            exact
            path="/chat/:ticketId?"
            component={Chat}
            isPrivate
          />
          <Route
            exact
            path="/connections/:filialId"
            component={Connections}
            isPrivate
          />
          <Route
            exact
            path="/quickAnswers"
            component={QuickAnswers}
            isPrivate
          />
          {/* <Route exact path="/contacts" component={Contacts} isPrivate />
              <Route exact path="/users" component={Users} isPrivate />
              <Route exact path="/Settings" component={Settings} isPrivate />
              <Route exact path="/Queues" component={Queues} isPrivate />
              <Route exact path="/ZDGChatbot" component={ZDGChatbot} isPrivate />
              <Route exact path="/ZDGAgendamento" component={ZDGAgendamento} isPrivate />
              <Route exact path="/ZDG" component={ZDG} isPrivate />
              <Route exact path="/ZDGMedia" component={ZDGMedia} isPrivate />
              <Route exact path="/ZDGGroups" component={ZDGGroups} isPrivate />
              <Route exact path="/InstaDirect" component={InstaDirect} isPrivate />
              <Route exact path="/SMS" component={SMS} isPrivate />
              <Route exact path="/VoiceCall" component={VoiceCall} isPrivate />
              <Route exact path="/ZDGHistorico" component={ZDGHistorico} isPrivate /> */}
        </LoggedInLayout>
      </WhatsAppsProvider>
    </Switch>
  );
};

const Routes = () => {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppGate />
        <ToastContainer autoClose={3000} />
      </AuthProvider>
    </BrowserRouter>
  );
};

export default Routes;
